import { keepPreviousData, useQuery } from '@tanstack/react-query';
import i18next from 'i18next';
import { getHome } from '../../services/apiHome';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

export function useHome() {
    const { slug } = useParams();

    const {
        isPending: isLoading,
        data: home,
        error,
        isSuccess,
        isFetching,
    } = useQuery({
        queryKey: ['home', i18next.language, slug],
        queryFn: () => getHome(slug),
        // enabled: !!slug,
        // staleTime: 0,
        // gcTime: 0,
        // refetchOnMount: 'always',
        // refetchOnWindowFocus: true,
        // retry: 1,
        enabled: !!slug,
        staleTime: 0,
        gcTime: 10 * 60 * 1000,
        refetchOnMount: 'always',
        refetchOnWindowFocus: true,
        // Keep prior home while language-keyed refetch runs so LayoutStore does not
        // unmount StoreProvider (that remount re-init was wiping the new language).
        placeholderData: keepPreviousData,
        retry: 1,
    });

    useEffect(() => {
        if (isSuccess && home?.data?.logo && slug) {
            // 🔥 حفظ بـ slug-specific key
            localStorage.setItem(`store-logo-${slug}`, home.data.logo);
        }
    }, [isSuccess, home, slug]); // ✅ أضف slug

    return { isLoading, error, home, isSuccess, isFetching };
}
